import * as FirstPartyFetchResponse from "../../../domain/models/FirstPartyFetchResponse";
import * as ListingSuccessResponse2 from "../../../domain/models/ListingSuccessResponse2";
import * as PartiesSuccessResponse1 from "../../../domain/models/PartiesSuccessResponse1";

export class C {
    public searchInput: string = "";
    public listingsSearchResponse: FirstPartyFetchResponse.T<ListingSuccessResponse2.T> = FirstPartyFetchResponse.create2XX(ListingSuccessResponse2.newDefault());
    public partiesSearchResponse: FirstPartyFetchResponse.T<PartiesSuccessResponse1.T> = FirstPartyFetchResponse.create2XX(PartiesSuccessResponse1.newDefault());
}
